module.exports = __webpack_public_path__ + "img/WiDE_Logo_Dark.25948cd9.png";